var _style, _rect, _polyline, _line, _line2, _line3, _line4, _line5, _line6, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceActivatedPneumaticHydraulicDoubleEffect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 6.5,
    className: "st0",
    width: 9,
    height: 5.3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "5.1,6.5 5.1,9.2 5.1,11.8 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.2,
    y1: 9.2,
    x2: 5.1,
    y2: 9.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.5,
    y1: 9.2,
    x2: 8.7,
    y2: 9.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.6,
    y1: 9.2,
    x2: 10.7,
    y2: 9.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.2,
    y1: 9.2,
    x2: 13.3,
    y2: 9.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.5,
    y1: 9.2,
    x2: 15.6,
    y2: 9.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 4.9,
    x2: 7.2,
    y2: 4.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3,4.3 3,5.5 2,4.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7.2,5.5 7.2,4.3 8.3,4.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceActivatedPneumaticHydraulicDoubleEffect);
export default __webpack_public_path__ + "static/media/DeviceActivatedPneumaticHydraulicDoubleEffect.792aafbcee30fb6fa9899328a42b2893.svg";
export { ForwardRef as ReactComponent };